<template>
  <div class="branded-fare-upsell__amenity__wrapper">
    <div class="branded-fare-upsell__amenity__top">
      <div class="branded-fare-upsell__amenity__icon">
        <vb-icon
          v-if="item.icon"
          class="d-flex align-items-center justify-content-center"
          :name="item.icon"
          :color="sass('primary')"
          :size="18"
        />
      </div>
      <div class="branded-fare-upsell__amenity__text">
        <div v-if="item.txt" class="branded-fare-upsell__amenity__name d-flex">
          <div :id="amenity_id" :ref="amenity_id" class="text-ellipsis">
            {{ item.txt | capitalize }}
          </div>
          <vb-icon
            v-if="item.tooltip"
            v-b-popover.hover.top="item.tooltip"
            class="ml-1"
            name="info"
            :size="14"
          />
        </div>
        <div
          v-if="item.description"
          class="branded-fare-upsell__amenity__description"
        >
          {{ item.description | capitalize }}
        </div>
      </div>
    </div>
    <div
      v-if="with_separator"
      class="branded-fare-upsell__separator fullwidth"
    ></div>
    <b-popover
      v-if="is_text_truncated($refs[amenity_id])"
      :target="amenity_id"
      triggers="hover"
      placement="top"
      custom-class="b-popover--primary b-popover--no-arrow"
    >
      <span class="text--base">{{ item.txt | capitalize }}</span>
    </b-popover>
  </div>
</template>

<script>
// Branded-fare amenity row: icon + label + optional tooltip and
// description. Consumes the object returned by get_amenity_info from
// @liveflight/resources. The swiper-item variant trails the row with a
// separator; the table cell doesn't — `with_separator` toggles it.
export default {
  name: "branded-fare-amenity",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    with_separator: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      amenity_id: `amenity:${this._uid}`,
    };
  },
};
</script>
